// extracted by mini-css-extract-plugin
export default {"item":"TherapeuticAreaItem_item__z7+mm"};